import React, { createContext, useState, useContext } from 'react';

// Create the context
const WebSearchContext = createContext();

// Create the provider component
export const WebSearchProvider = ({ children }) => {
    const [webSearch, setWebSearch] = useState(''); // Ensure consistency in naming

    return (
        <WebSearchContext.Provider value={{ webSearch, setWebSearch }}>
            {children}
        </WebSearchContext.Provider>
    );
};

// Custom hook to use the WebSearchContext
export const useWebSearch = () => {
    const context = useContext(WebSearchContext);
    if (!context) {
        throw new Error('useWebSearch must be used within a WebSearchProvider');
    }
    return context; // Return webSearch and setWebSearch from context
};
